import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import axios from "axios";
import { LOGIN } from "../constants";

const ProtectedRoute = (props:any) => {
	if (props.isAuthenticated === null) return <p>Loading...</p>;

	return props.isAuthenticated ? <Outlet /> : <Navigate to={LOGIN} />;
};

export default ProtectedRoute;
